

const States = ['NSW','ACT','QLD','VIC','TAS','NT','SA'];
export default States;